export class ColumnEvent {
    sourceColumn: string | null;

    constructor({ sourceColumn }: ColumnEvent) {
        this.sourceColumn = sourceColumn;
    }
}
